// extracted by mini-css-extract-plugin
module.exports = {"animate":"StarRating_animate__3YAiQ","bounce":"StarRating_bounce__GJ8kX"};